<template>
  <div class="call_out_plan">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="title" placeholder="请输入标题" title="标题"/>
      </div>
      <div class="fixed_search_input" >
        <Select v-model="author" :clearable="true" placeholder="请选择更新人员" title="更新人员">
            <Option v-for="item in authorList" :key="item.id" :label="item.employeeName" :value="item.id"></Option>
        </Select>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始创建时间" end-placeholder="结束创建时间"
                        align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_operation_btn" style="width: auto">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="info" @click="addNotice" v-if="roleList['9_6-1']">添加</Button>
      </div>
    </div>
        <div class="fixed_table">
          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
          <div class="table_head">
            <table style="white-space: nowrap;">
              <tr>
                <th class="font_style_set" style="width: 8%">已读人数</th>
                <th class="font_style_set" style="width: 15%">标题</th>
                <th class="font_style_set" style="width: 15%">更新人员</th>
                <th class="font_style_set" style="width: 15%">创建时间</th>
                <th class="font_style_set" style="width: 15%">更新时间</th>
                <!-- <th class="font_style_set" style="width: 12%">备注</th> -->
                <th class="font_style_set" style="width: 20%">操作</th>
              </tr>
            </table>
          </div>
          <div class="footer_style" :style="tableHeight">
            <table class="table_head_footer">
              <tr v-for="(item , index) in TableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                <td class="font_style_set" style="width: 8%">
                    <el-popover
                      placement="top-start"
                      width="400"
                      trigger="click"
                      class="noticePopover">
                      <p style="width: 100%;margin-bottom:20px">
                        <el-link :underline="false" :type="activeName==1?'primary':'info'" @click="activeName=1" style="width: 50%;"><h2 style="float: left;margin-top: -15%">{{item.readNum}}</h2>已读</el-link><el-link :underline="false" :type="activeName==2?'primary':'info'" @click="activeName=2" style="width: 50%;"><h2 style="float: left;margin-top: -15%">{{item.unreadNum}}</h2>未读</el-link></p>
                        <!-- 已读 -->
                        <div v-show="activeName ==1 " >
                            <el-table :data="readList" style="width: 100%" height=300>
                              <el-table-column prop="employeeCode" label="员工编号" align="center" :show-overflow-tooltip="true"> </el-table-column>
                              <el-table-column prop="employeeName" label="员工姓名" align="center" :show-overflow-tooltip="true"> </el-table-column>
                            </el-table>
                        </div>
                        <!-- 未读 -->
                        <div class="fixed_table" v-show="activeName ==2 ">
                            <el-table :data="unreadList" style="width: 100%" height=300>
                              <el-table-column prop="employeeCode" label="员工编号" align="center" :show-overflow-tooltip="true"> </el-table-column>
                              <el-table-column prop="employeeName" label="员工姓名" align="center" :show-overflow-tooltip="true"> </el-table-column>
                            </el-table>
                        </div>
                      <a v-if="item.unreadNum == 0" href="javascript:void(0)" class="undelined_out_call" slot="reference" @click="readAndUnread(item.id)">全部已读</a>
                      <a v-if="item.unreadNum != 0" href="javascript:void(0)" class="undelined_out_call" slot="reference" @click="readAndUnread(item.id)">{{item.readNum}}</a>
                    </el-popover>
                </td>
                <td class="font_style_set" style="width: 15%"  :title="item.title">{{item.title}}</td>
                <td class="font_style_set" style="width: 15%" :title="item.employeeName">{{item.employeeName}}</td>
                <td class="font_style_set" style="width: 15%" :title="item.createTime">{{item.createTime}}</td>
                <td class="font_style_set" style="width: 15%" :title="item.updateTime">{{item.updateTime}}</td>
                <!-- <td class="font_style_set" style="width: 12%" :title="item.descr">{{item.descr}}</td> -->
                <td class="template_table_btn" style="width: 20%">
                  <span class="search_btn" @click="seeNotice(item)" v-if="roleList['9_6-4']">查看</span>
                  <span class="search_btn" v-show="item.isPublish == 0" @click="releaseNotice(item)" v-if="roleList['9_6-5']">发布</span>
                  <span class="search_btn" v-show="item.isPublish == 0" @click="editNotice(item)" v-if="roleList['9_6-2']">编辑</span>
                  <span class="search_btn" @click="deleteNotice(item.id)" v-if="roleList['9_6-3']">删除</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    
    <InsertNotice :showInsertNotice="showInsertNotice" :notice="noticeId" @closeNotice="closeNotice" @initSearch="initSearch"></InsertNotice>
    <!-- <SeeNotice :showSeeNotice="showSeeNotice" :notice="noticeId" @closeNotice="closeNotice"></SeeNotice> -->
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import InsertNotice from '@/components/userManagement/InsertNotice.vue'
    import SeeNotice from '@/components/userManagement/SeeNotice.vue'
    export default {
        name: "Notice",
        mixins:[publicFunClass],
        components:{
         InsertNotice,
        //  SeeNotice
        },
        props:{
          pageCode:String,
          showNotice:Boolean
        },
        data(){
          return {
            showSeeNotice:false,
            activeName:"1",
            spinShow:false,
            roleList: JSON.parse(localStorage.getItem("roleList")),
            agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
            editable:false,
            tableHeight:{height:''},
            showPageCount:0,
            total: 0,
            pageSizeList: [10, 20, 30, 40, 50, 100, 200],
            speedChangePage: 1,
            currentPage: 1,
            pageSize: 20,
            title:'',
            starEndTime:[],
            author:'',
            readList:[],
            unreadList:[],
            TableList:[],
            authorList:[],
            formValidate:{"searchList":[],"seniorList":[],"allColumnInfo":[]},
            showInsertNotice:false,
            noticeId:'',
          }
        },
        methods:{
            //查看已读未读
            readAndUnread(id){
              this.activeName=1;
              this.unreadList=[];
              this.readList=[];
              this.readDate=[];
              let that=this;
                let param={
                  id:id
                };

              this.$http.post("notice/toReadAndUnread.json",param) .then(function (res) {
                let result=res.data;
                if(result.flag!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                // console.log(result);
                result.obj.forEach(item => {
                  if(item.isRead == "0"){
                    that.unreadList.push(item);
                  }else{
                    that.readList.push(item);
                  }
                });
                
                that.TableList.forEach(item=>{
                  if(item.id == id){
                    item.readNum=that.readList.length;
                    item.unreadNum=that.unreadList.length;
                  }
                });
              })

            },
            //关闭
            closeNotice:function(){
                this.showInsertNotice=false;
                this.showSeeNotice=false;
            },
            //查询
            initSearch:function(){
                let that=this;
                let param={
                  title:this.title,
                  author:this.author,
                  starEndTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
                  isPublishId:'',
                  pageNum:this.currentPage,
                  pageSize:this.pageSize,
                  journalType:"null",
                  menuId:"null",
                };
                this.spinShow=true;

                this.$http.post("notice/toIndex.json",param) .then(function (res) {
                  let result=res.data;
                  that.spinShow=false;
                  if(result.flag!="666"){
                    that.$Modal.info({
                      title:'提示',
                      content:res.data.msg
                    });
                    return false;
                  }
                
                  that.TableList=result.obj.list.content;
                  that.authorList=result.obj.empList;
                  that.total=result.obj.list.totalSize;
                  // console.log(that.TableList);
                })
            },
            //添加
            addNotice:function(){
                this.noticeId='';
                this.showInsertNotice=true;
            },  
            //发布
            releaseNotice:function(item){
              this.$Modal.confirm({
              title: '提示',
              content: "是否确定发布",
              onOk: () => {
                let temp={
                  updateTime:item.updateTime,
                  title:item.title,
                  type:"pushNoticerMessage",
                  sessionChannel:"Notice",
                  agentNumber:this.agentInfo.employeeId,
                  msgSource:'',
                  id:item.id,
                };
                let that =this;
                let param={
                  id:item.id,
                  isRelease:'1',
                  temp:temp,
                };
                this.$http.post("notice/releaseNotice.json",param) .then(function (res) {
                  let result=res.data;
                  if(result.flag!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("发布成功");
                  that.initSearch();
                })
              }
            });
              
            },
            //查看
            seeNotice:function(item){
                
                this.$emit("noticeShow",item);
                // this.noticeId=JSON.stringify(item);
                // this.showSeeNotice=true;
            },
            //编辑
            editNotice:function(item){
                this.noticeId=JSON.stringify(item);;
                this.showInsertNotice=true;
            },
            //删除
            deleteNotice:function(id){
              this.$Modal.confirm({
              title: '提示',
              content: "是否确定删除",
              onOk: () => {
                let that=this;
                let param={
                  id:id
                };
                this.$http.post("notice/doDelete.json",param) .then(function (res) {
                  let result=res.data;
                  if(result.flag!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.initSearch();
                })
              }
            });
              
                
            },

        },
        created(){
            this.tableHeight.height=this.mountHeight(220);
        },
        watch:{
          pageCode:function () {
            if(this.pageCode=='9_6' && this.showPageCount==0){
              this.showPageCount++;
              this.initSearch();
            }
          }
        }
    }
</script>

<style >
.el-popover{
    background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/userManagement/Notice.vue